/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Static information to identify a ship. To query a given ship provide any information available. Using more information will enhance the chance for identification.
 * @export
 * @interface Ship
 */
export interface Ship {
    /**
     * 
     * @type {number}
     * @memberof Ship
     */
    mmsi?: number;
    /**
     * 
     * @type {number}
     * @memberof Ship
     */
    imo?: number;
    /**
     * 
     * @type {string}
     * @memberof Ship
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof Ship
     */
    callsign?: string;
    /**
     * 
     * @type {number}
     * @memberof Ship
     */
    length?: number;
    /**
     * 
     * @type {number}
     * @memberof Ship
     */
    width?: number;
    /**
     * Draught of the ship [m]. Notice this info may change for each voyage.
     * @type {number}
     * @memberof Ship
     */
    draught?: number;
    /**
     * Displacement of the ship. Notice this info is not available in the AIS information.
     * @type {number}
     * @memberof Ship
     */
    grt?: number;
    /**
     * If true the system will create an entry with this ship if it cannot find any information on the ship. This can be useful for ships without an AIS transponder.
     * @type {boolean}
     * @memberof Ship
     */
    create?: boolean;
    /**
     * Expected Time of Arrival as indicated in the AIS message.
     * @type {string}
     * @memberof Ship
     */
    eta?: string;
    /**
     * Destination as indicated in the AIS message.
     * @type {string}
     * @memberof Ship
     */
    destination?: string;
    /**
     * United Nations Country name. See http://www.unece.org/cefact/locode/service/location.
     * @type {string}
     * @memberof Ship
     */
    country?: string;
    /**
     * Textual description of ship type. Based on the AIS information. May also include cargo
     * @type {string}
     * @memberof Ship
     */
    shiptype?: string;
    /**
     * Two-letter country code
     * @type {string}
     * @memberof Ship
     */
    a2?: string;
    /**
     * 
     * @type {number}
     * @memberof Ship
     */
    sog?: number;
}

/**
 * Check if a given object implements the Ship interface.
 */
export function instanceOfShip(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipFromJSON(json: any): Ship {
    return ShipFromJSONTyped(json, false);
}

export function ShipFromJSONTyped(json: any, ignoreDiscriminator: boolean): Ship {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mmsi': !exists(json, 'mmsi') ? undefined : json['mmsi'],
        'imo': !exists(json, 'imo') ? undefined : json['imo'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'callsign': !exists(json, 'callsign') ? undefined : json['callsign'],
        'length': !exists(json, 'length') ? undefined : json['length'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'draught': !exists(json, 'draught') ? undefined : json['draught'],
        'grt': !exists(json, 'grt') ? undefined : json['grt'],
        'create': !exists(json, 'create') ? undefined : json['create'],
        'eta': !exists(json, 'eta') ? undefined : json['eta'],
        'destination': !exists(json, 'destination') ? undefined : json['destination'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'shiptype': !exists(json, 'shiptype') ? undefined : json['shiptype'],
        'a2': !exists(json, 'a2') ? undefined : json['a2'],
        'sog': !exists(json, 'sog') ? undefined : json['sog'],
    };
}

export function ShipToJSON(value?: Ship | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mmsi': value.mmsi,
        'imo': value.imo,
        'name': value.name,
        'callsign': value.callsign,
        'length': value.length,
        'width': value.width,
        'draught': value.draught,
        'grt': value.grt,
        'create': value.create,
        'eta': value.eta,
        'destination': value.destination,
        'country': value.country,
        'shiptype': value.shiptype,
        'a2': value.a2,
        'sog': value.sog,
    };
}

